<template>
  <v-row no-gutters>
    <v-col cols="12">
      <v-row no-gutters>
        <v-col cols="12" class="relative-container">
          <v-row no-gutters>
            <v-col cols="12" v-if="!isUploadFileActive">
              <v-sheet class="upload-files-drag-drop-container">
                <v-row no-gutters class="pa-4 d-flex align-center">
                  <v-col cols="2">
                    <v-icon color="#255D98" large class="mr-3 mdi-size">
                      mdi-upload
                    </v-icon>
                  </v-col>
                  <v-col cols="10">
                    <span class="action-text">{{$t('message.adminPage.payment.dragAndDrop')}}
                      <span class="action-text-btn pl-1" style="position:relative ; z-index: 100; cursor: pointer;" @click="activeFilepond(is_payment_evidence)">
                        {{$t('message.adminPage.payment.upload')}}
                      </span>
                    </span>
                  </v-col>
                </v-row>
              </v-sheet>
            </v-col>
            <v-col cols="12" :class="dragDropClass">
              <file-pond
                v-if="is_payment_evidence"
                name="filepond"
                ref="pond"
                :label-idle="idleHtml"
                v-bind:allow-multiple="true"
                accepted-file-types="image/jpg, image/jpeg, image/png"
                v-bind:files="uploadFiles"
                @init="handleFilePondInit"
                @addfile="handleAddFile"
                id="filepond-browser-1"
              />
              <file-pond
                v-else
                name="filepond"
                ref="pond"
                :label-idle="idleHtml"
                v-bind:allow-multiple="true"
                accepted-file-types="application/pdf, image/jpg, image/jpeg, image/png"
                v-bind:files="uploadFiles"
                @init="handleFilePondInit"
                @addfile="handleAddFile"
                id="filepond-browser-2"
              />
            </v-col>
          </v-row>
        </v-col>
      </v-row>
      <!-- ไฟล์ที่อัพโหลด -->
      <v-row no-gutters class="mt-3">
        <v-col cols="12" v-for="(file, i) in files" :key="i" class="mt-2 pa-2">
          <v-fade-transition>
            <v-sheet
              :color="'#fafafd'"
              rounded="lg"
              class="file-input-class"
            >
              <v-row no-gutters align="center" justify="space-between">
                <v-col cols="10">
                  <v-row no-gutters align="center">
                    <v-col cols="2">
                      <v-sheet
                        v-if="!file.error"
                        :color="file.color"
                        rounded="lg"
                        class="pa-1 ma-1"
                        width="34"
                        height="34"
                      >
                      <div class="d-flex justify-center mt-1">
                        <v-icon v-text="file.icon" color="#FFF"></v-icon>
                      </div>
                      </v-sheet>
                      <v-sheet
                        v-else
                        :color="'#FF544A'"
                        rounded="lg"
                        class="pa-1 ma-1"
                        width="34"
                        height="34"
                      >
                      <div class="d-flex justify-center mt-1">
                        <v-icon v-text="file.icon" color="#FFF"></v-icon>
                      </div>
                      </v-sheet>
                    </v-col>
                    <v-col cols="10">
                      <span
                        :class="
                          file.error
                            ? 'default-text-14 ml-2 d-flex align-center'
                            : 'default-text-14 ml-2 d-flex align-center'
                        "
                      >
                        <template v-if="file.error">
                          <v-row no-gutters class="file-input-text">
                            {{ $t(`${file.errorMsg.main}`) }}
                          </v-row>
                        </template>

                        <template v-else>
                          <v-row
                            v-if="file.url != null && file.url != ''"
                            no-gutters
                            class="file-input-text cursor--pointer"
                            @click="pdfViewer(file)"
                          >
                            {{ file.name }}
                          </v-row>
                          <v-row
                            v-else
                            no-gutters
                            class="file-input-text"
                          >
                            {{ file.name }}
                          </v-row>
                        </template>
                      </span>
                    </v-col>
                  </v-row>
                </v-col>
                <v-col cols="2">
                  <v-row no-gutters align="center" justify="end">
                    <v-btn
                      icon
                      small
                      v-if="file.ableToEdit"
                      class="mr-2"
                      @click="onRemove(file, i)"
                    >
                      <v-icon small>{{
                        "mdi-delete"
                      }}</v-icon>
                    </v-btn>
                  </v-row>
                </v-col>
              </v-row>
            </v-sheet>
          </v-fade-transition>
        </v-col>
      </v-row>
    </v-col>
    <pdf-viewer ref="pdfViewer"></pdf-viewer>
  </v-row>
</template>

<script>
import { dateTime, dateTimeLocale } from "@/utils/date";
import * as services from "@/services";
import { getFileExtensionFromUrl } from "@/utils/extension";
import { getContentType } from "@/utils/contentType";
import i18n from "@/i18n";
import PdfViewer from '@/components/common/PdfViewer.vue'

export default {
    components: {
      PdfViewer,
    },
    props: {
      filesProp: Array,
      is_payment_evidence: Boolean,
      student_id: Number,
    },

    data() {
        return {
            idleHtml: i18n.t('message.adminPage.payment.fullDragAndDrop'),
            isUploadFileActive: false,
            files: [],
            uploadFiles: [],
            pdfUrl: null
        };
    },
    mounted() {
        this.retrievedData();
    },
    computed: {
        dragDropClass() {
            try {
                if (this.isUploadFileActive) return "drag-drop-active";
                return "drag-drop-hidden";
            } catch (error) {
                return "";
            }
        },
    },
    methods: {
        showAlert(status, text) {
            this.$emit("showAlert", status, text);
        },
        retrievedData() {
            let files = JSON.parse(JSON.stringify(this.filesProp));
            this.files = files;
            for(let i = 0 ; i < files.length ; i++){
              if(files[i].url == null || files[i].url == '' || files[i].url.includes('deleted_')){
                files[i]['error'] = true;
                files[i]['errorMsg'] = {
                  main: 'message.adminPage.file.expired',
                }
              }

            }
        },
        activeFilepond(is_payment){
          if(is_payment==false){
            document.querySelector('#filepond-browser-2 input').click();
          }else{
            document.querySelector('#filepond-browser-1 input').click();
          }
        },
    handleFilePondInit(){

    },
    // use add file
    async handleAddFile(error, file) {
      try {
          this.$emit("loadingUpdate", 1);
          if (file.fileSize > 1048576 * 10) { // 10 Mb
            this.files.push({
              name: file?.file?.name,
              icon: "mdi-paperclip",
              color: "#BF9983",
              ableToEdit: true,
              error: true,
              errorMsg: {
                main: 'message.adminPage.file.overSize',
              },
            });
            throw error;
        }
        // eslint-disable-next-line
            const fileRegex = /[!@#$%^&*()+\=\[\]{};':"\\|,<>\/?]/;
            if(fileRegex.test(file?.file?.name)){
                this.files.push({
                  name: file?.file?.name,
                  icon: "mdi-paperclip",
                  color: "#BF9983",
                  ableToEdit: true,
                  error: true,
                  errorMsg: {
                    main: i18n.t('message.adminPage.file.changeFileName'),
                  },
                });
                throw error;
            }

        if (error) {
          this.files.push({
            name: file?.file?.name,
            icon: "mdi-paperclip",
            color: "#BF9983",
            ableToEdit: true,
            error: true,
            errorMsg: {
              main: 'message.adminPage.file.errorUpload',
            },
          });
          throw error;
        }
        let pond = this.$refs?.pond;

        this.isUploadFileActive = true;
        // TODO post to endpoint - then if upload success
        let uploadSuccess = true;
        if (uploadSuccess) {
          const formData = new FormData();
          formData.append("file", file.file);

          let uploadRes = null
          try{
            const {
              data,
            } = await services.uploadFile(formData, {
              module: "ENROLL_STUDENT_EVIDENCE",
              fileName: file.file.name,
              student_id: this.student_id,
              date: dateTime("YYYY-MM-DD"),
            });
            uploadRes = data
            if(uploadRes?.data?.status != "ok"){
              throw data
            }
            else{
              uploadRes = data.data
            }
          }
          catch(error){
            console.log(error)
            throw error
          }

          this.files.push({
            id: uploadRes?.params?.id,
            name: file?.file?.name,
            icon: "mdi-paperclip",
            color: "#BF9983",
            ableToEdit: true,
            url: uploadRes?.url
          });
          if (this.is_payment_evidence) {
            await services.addPaymentBackOffice({
              id: this.student_id,
              transaction: {
                payment_evidence: uploadRes?.url,
              },
            });

            this.$emit("onUploadPayment", {
              id: this.student_id,
              transaction_number: "-",
              is_student_upload: false,
              txn_date: dateTimeLocale(),
              payment_amount: 0,
              document_name: file?.file?.name,
            });
          }
          else{
            this.$emit("onUploadFile", {
              id: uploadRes?.params?.id,
              name: file?.file?.name,
              icon: "mdi-paperclip",
              color: "#BF9983",
              ableToEdit: true,
              url: uploadRes?.url
            })
          }

          setTimeout(() => {
            pond.removeFile();
            this.isUploadFileActive = false;
          }, 500);
        }
      } catch (error) {
        console.log(error);
        let pond = this.$refs?.pond;
        pond.removeFile();
        this.isUploadFileActive = false;
      }
      finally{
        this.$emit("loadingUpdate", -1);
      }
    },

    // use delete file
    async onRemove(file, i) {
      let pond = this.$refs?.pond;
      let res = await this.$swal.fire({
        icon: "warning",
        title: i18n.t('message.adminPage.modal.removeModal'),
        text: i18n.t('message.adminPage.modal.removeModalContent'),
        iconColor: "#FF544A",
        showCancelButton: true,
        confirmButtonText: i18n.t('message.adminPage.button.confirm'),
        cancelButtonText: i18n.t('message.adminPage.button.cancel'),
        reverseButtons: true,
        confirmButtonColor: "#FF544A",
        cancelButtonColor: "#FF9800",
        customClass: {
          icon: "swal2-warning-bg",
        },
        showCloseButton: true,
      });
      if (res.isConfirmed) {
        try{
          this.$emit("loadingUpdate", 1);
          // TODO to api

          if(!file.error){
            // Delete normal file
            console.log("delete normal file");
            await services.deleteDocumentFile(
              {
                module: "ENROLL_STUDENT_EVIDENCE",
                fileName: file.name,
                fileId: file.id
              },
              this.student_id
            );
          }
          else{
            // Delete expire file
            if(file?.id != undefined && file?.id != null){
              await services.deleteDocumentFile(
                {
                  module: "ENROLL_STUDENT_EVIDENCE",
                  fileName: file.name,
                  fileId: file.id
                },
                this.student_id
              );
            }
          }

          if (this.is_payment_evidence) {
            this.$emit("onDeleteFile", file.name);
          }
          else{
            this.$emit("onDeleteFile", file.id);
          }
          this.showAlert("success", i18n.t('message.adminPage.successfulDeleteFile'));
          this.files.splice(i, 1);
          pond.removeFile();
        }
        catch(err){
          console.log(err);
        }
        finally{
          this.$emit("loadingUpdate", -1);
        }
      }

    },

    async download(file) {
      try {
        if(!file.error){
          const res = await services.downloadFile({
            file_name: file.name,
            file_url: file.url,
          });
          const extension = getFileExtensionFromUrl(file.url);
          const blob = new Blob([res.data], {
            type: getContentType(extension),
          });
          const downloadUrl = URL.createObjectURL(blob);
          const a = document.createElement("a");
          a.target = "_blank";
          a.href = downloadUrl;
          a.download = file.name;
          document.body.appendChild(a);
          a.click();
        }
      } catch (error) {
        console.log(error);
      }
    },
    pdfViewer(file) {
      //this.$refs.pdfViewer.getPdf(file);
      window.open(file?.url, '_blank').focus();
    }
  },
};
</script>

<style scoped lang="scss">
.file-input-text {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  display: inline-block;
  max-width: 330px !important;
}
.file-input-class {
  position: relative;
}
.drag-drop-active {
  opacity: 100;
  position: relative;
  transition: all;
}
.drag-drop-hidden {
  opacity: 0;
  position: absolute;
  transition: all;
}
.relative-container {
  position: relative;
}
.action-text {
  color: #afadb1;
  font-weight: 400;
  font-family: "Sarabun";
  font-style: normal;
  font-size: 16px;
  line-height: 21px;
}
.action-text-btn {
  color: #ff9800;
  cursor: pointer;
  text-decoration: underline;
  font-weight: 500;
  font-family: "Prompt";
  font-style: normal;
  font-size: 16px;
  line-height: 21px;
}
.upload-files-drag-drop-container {
  /* Dark/Nav 50 - FAFAFD */

  background: #fafafd;
  /* Neutrals/D4D9DE */

  border: 2px dashed #d4d9de;
  border-radius: 10px;
}
.file-card-rounded {
  background: #fafafd;
  border-radius: 10px;
}
.underline-text {
  font-family: "Prompt";
  font-style: normal;
  font-weight: 400;
  font-size: 18px;
  line-height: 24px;
  /* identical to box height, or 133% */

  text-decoration-line: underline;

  /* Primary/Primary 500 - FF9800 */

  /* color: #ff9800; */
}
.header-text {
  font-family: "Prompt";
  font-style: normal;
  font-weight: 400;
  font-size: 18px;
  line-height: 23px;
  color: #255d98;
}
.caption-text {
  font-family: "Prompt";
  font-weight: 400;
  font-size: 14px;
  line-height: 18px;
  color: #9d9b9a;
}
.default-text-14 {
  font-family: "Prompt";
  font-weight: 400;
  font-size: 14px;
  line-height: 18px;
  color: #37323c;
}
.default-text-14-white {
  font-family: "Prompt";
  font-weight: 400;
  font-size: 14px;
  line-height: 18px;
  color: #fff;
}
.default-text {
  font-family: "Sarabun";
  font-weight: 400;
  font-size: 18px;
  line-height: 24px;
  color: #37323c;
}

#upload_cursor{
  cursor:grab;
}

[class*="-text"] {
    .v-application[lang="en"] & {
        font-family: "inter", sans-serif !important;
    }
}

@media only screen and (max-width: 1260px) {
  .file-input-text {
    max-width: 900px;
  }

  .mdi-size{
    font-size: 200px;
  }
}
@media only screen and (min-width: 1600px) {
  .file-input-text {
    max-width: 250px;
  }
}
</style>
